import { render, staticRenderFns } from "./RuleMetricCalculation.ts.vue?vue&type=template&id=effcf78c"
import script from "./RuleMetricCalculation.ts.vue?vue&type=script&lang=ts"
export * from "./RuleMetricCalculation.ts.vue?vue&type=script&lang=ts"
import style0 from "./RuleMetricCalculation.ts.vue?vue&type=style&index=0&id=effcf78c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports